import { createContext } from 'react';

export type FlagValue = boolean | string | number | (string | number)[];
export type FlagSet = Record<string, FlagValue>;

export const FlagsContext = createContext<FlagSet>({});
FlagsContext.displayName = 'FlagsContext';

export const FlagsProvider = FlagsContext.Provider;
export const FlagsConsumer = FlagsContext.Consumer;
